import { Box as AtomicBox } from 'atomic-layout';
import styled, { css } from 'styled-components';

import {
  ColorTypes,
  ColorValues,
  FontWeight,
  TextAligns,
} from '@/types/styles';
import { BoxProps } from '@atomic-layout/core';

export interface IBox extends BoxProps {
  backgroundColorType?: ColorTypes;
  backgroundColorValue?: ColorValues;
  fontWeight?: FontWeight;
  colorType?: ColorTypes;
  colorValue?: ColorValues;
  pointer?: boolean;
  textAlign?: TextAligns;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
const Box = styled(AtomicBox)<IBox>`
  ${({ theme, backgroundColorType, backgroundColorValue }) =>
    backgroundColorType &&
    css`
      background-color: ${theme.colors[backgroundColorType][
        backgroundColorValue || 0
      ]};
    `};

  ${({ theme, colorType, colorValue }) =>
    colorType &&
    css`
      color: ${theme.colors[colorType][colorValue || 0]};
    `};

  ${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `}

  ${({ pointer }) =>
    pointer &&
    css`
      cursor: pointer;
    `}

  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
`;

export default Box;
